import axios from 'axios'
import MptcfeUtils from 'mptcfe-utils'
import CookieUtil from '../utils/cookie'
import Util from "../utils/util"
const { queryString, queryStringByUrl } = Util

const Utils = MptcfeUtils.Utils
const TimeOut = 3000 // 设置超时时间

function getCommonHeader(param) {
      let referObj = queryString() // 当前页url参数

      let result = {
        clientType: 1, // 1：wap
        suv: CookieUtil.get("SUV"),
        pvId: window.sohuSpm.getCodes().e, // pvid为当前页面spm码的e码
        requestId: param.requestId,
        Openid: CookieUtil.get("SUV"),
        // refer参数（跳转页面url）
        referSpm: referObj.spm, // 当前页url上的spm
        referScm: queryStringByUrl(document.referrer).scm, // 来源页面url上的scm
        referPath: document.referrer.slice(0, 200), // 来源页面的path

        // referer参数，当前页面url
        refererSpm: param.spm, // 当前页a.b.c.d.e
        refererScm: referObj.scm, // 当前页url上的scm参数
        refererPath: window.location.pathname, // 当前页path

        trans: referObj.trans,
      }
    // 焦点携带token
    if(window.focusUmabRefreshToken) {
        result.Authorization = window.focusUmabRefreshToken || ''
    }
      for (var p in result) {
        if (result[p] == undefined) {
          delete result[p]
        }
      }
      return result
}

axios.interceptors.response.use(res => {
    if (res.status === 200) {
        return Promise.resolve(res)
    } else {
        return Promise.reject(res)
    }
})

axios.defaults.withCredentials = true

const urlMap = {
    uis: {
        test: '//test-uis.mp.sohu.com',
        prod: '//uis.mp.sohu.com',
        pre: '//uis.mp.sohu.com'
    },
    us: {
        test: "//test-uis.mp.sohu.com",
        pre: "//us.mp.sohu.com",
        prod: "//us.mp.sohu.com",
    },
    discuss:{
        test: '//test-uis.mp.sohu.com/wap',
        prod: '//uis.mp.sohu.com/wap',
        pre: '//uis.mp.sohu.com/wap'
    },
    feedback: {
        test: '//test-uis.mp.sohu.com/advice',
        prod: '//uis.mp.sohu.com/advice',
        pre: '//uis.mp.sohu.com/advice'
    },
    v2: {
        test:'//test.mp.sohu.com/fe',
        pre:'//v2.sohu.com/mpfe',
        prod:'//v2.sohu.com/mpfe',
    }
}
const envMap = ['test', 'pre', 'prod'];
const Environment = envMap.indexOf(window.deployEnv) > -1 ? window.deployEnv : Utils.getEnvironment(); // 获取运行环境

const axiosFactory = function(urlType, env){ // 配置axios的工厂
    let instance = axios.create({
        baseURL: urlMap[urlType][env],
        timeout: TimeOut
    })
    return instance;
}

export const randomString = (e) => {
    e = e || 32;
    var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
    for (let i = 0; i < e; i++)
        n += t.charAt(Math.floor(Math.random() * a));
    return n;
}

/**
 * @description 获取唯一字符串
 * @param length
 */
export const getRequestId = (length = 16) => {
    const prefix = new Date().getTime().toString()
    if(length < prefix.length) return randomString(length)
    const suffixLength = length - prefix.length
    const suffix = randomString(suffixLength)
    return prefix + suffix
}

export const getDiscussInfoById = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/vote/info/id', {
            params,
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
            if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
                if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                    // 超时上报
                    window.sohuSpm.sendAction({
                        acode: '9601',
                        clkParam: `spm:${params.spm};interface:${urlMap.discuss[Environment]}/vote/info/id`
                    });
                }
            }
            else reject(error)
        })
    })
}
// 发送投票
export const sendVote = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/view/v2/vote', params,{
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}
// 取消投票
export const cancelVote = (params)=>{
    let discussAxios = axiosFactory('discuss', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/community/change/state', params,{
            headers: getCommonHeader(params)
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

//  获取反馈list
export const getFeedbackList = (params)=>{
    let discussAxios = axiosFactory('feedback', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/home/advice/cause/find', {
            params,
            headers: getCommonHeader(params)
        })
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}

// 获取封禁信息
export const getUserBannedInfo = ()=>{
    let axiosFn = axiosFactory('uis', Environment);
    return new Promise((resolve, reject) => {
        axiosFn.get('/comment/api/user', {
            params:{},
        })
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}
// 获取未读消息数量
export const getUnreadMessageCount = ()=>{
    let axiosFn = axiosFactory('uis', Environment);
    return new Promise((resolve, reject) => {
        axiosFn.get('/wap/api/message/unread_count', {
            params:{appId: 100016},
        })
        .then(res => {
            resolve(res.data)
        }).catch(error => {
            console.log('error',error)
            reject(error)
        })
    })
}


// 获取功能卡信息
export const getCardInfo = (params)=>{
    let discussAxios = axiosFactory('v2', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/card/get', {
            params,
            headers: {
                'Authorization': window.focusUmabRefreshToken || '',
                'tourist': CookieUtil.get('SUV')
            }
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

// check订阅状态
export const followCheck = (params)=>{
    let discussAxios = axiosFactory('us', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.get('/api/follow/check', {
            params,
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}

// 订阅
export const followAccount = (params)=>{
    let discussAxios = axiosFactory('us', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/follow',params,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}
// 取消订阅
export const unFollowAccount = (params)=>{
    let discussAxios = axiosFactory('us', Environment);
    return new Promise((resolve, reject) => {
        discussAxios.post('/api/follow/unfollow',params,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            resolve(res.data)
        }).catch(error => {
        })
    })
}